import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ModalEl } from "common/components/modal";
import { Visibility } from "common/components/base/stackable";
export function template() {
  var _a;
  return /* @__PURE__ */ jsx(ModalEl, {
    sel: ".secret-code-modal",
    attrs: {
      open: true,
      closeable: true
    },
    on: {
      change: ({ detail }) => detail.state === Visibility.Closed && this.helpers.closeSecretCodeModal()
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".secret-code-modal-container"
  }, /* @__PURE__ */ jsx("h1", {
    sel: ".secret-code-modal-title"
  }, "Your Two-Factor Secret"), /* @__PURE__ */ jsx("div", {
    sel: ".secret-code-modal-subtitle"
  }, "Enter this manual code in your authentication app to set up two-factor authentication."), /* @__PURE__ */ jsx("div", {
    sel: ".secret-code-container"
  }, (_a = this.attr(`secret`)) == null ? void 0 : _a.split(``).map((char, idx) => (idx + 1) % 4 === 0 ? char + ` ` : char).join(``)), /* @__PURE__ */ jsx("div", {
    sel: ".secret-code-modal-close-btn-container"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".secret-code-modal-close-btn",
    attrs: {
      theme: ButtonTheme.Primary
    },
    on: {
      click: this.helpers.closeSecretCodeModal
    }
  }, "Close"))));
}
